import { render, staticRenderFns } from "./SlotTabs.vue?vue&type=template&id=0ba48eca&scoped=true"
import script from "./SlotTabs.vue?vue&type=script&lang=ts"
export * from "./SlotTabs.vue?vue&type=script&lang=ts"
import style0 from "./SlotTabs.vue?vue&type=style&index=0&id=0ba48eca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba48eca",
  null
  
)

export default component.exports